/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';
import { Box, Button, Dialog, DialogActions, Grid, MenuItem, Select, Typography } from '@mui/material';

import {
  DELETE_HOMESALE_RESALE_OFFER_FAILURE,
  GET_ALL_HOMESALE_RESALE_OFFER_FAILURE,
  POST_HOMESALE_RESALE_OFFER_FAILURE
} from 'modules/authorizations/store/types/homesaleTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  deleteHomesaleResaleOffer,
  getHomesaleResaleOffers,
  postHomesaleResaleOffer
} from 'modules/authorizations/store/actions/homesale.actions';
import { showToast } from 'modules/layout/layout.actions';
import AdvancedSearch from 'modules/common/advancedSearch.component';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import ResaleOffersCard from './resaleOffersCard.component';
import Spinner from 'modules/common/spinner.component';
import { brokerSearchInfo } from './inspections/FormFields/inspectionsFormFields';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

const activeListingStatusId = '5462aeca-0424-4578-a841-0cfbc871366e';

const ResaleOffers = props => {
  const { authId, brokerAgents, isReadOnly, enumerations, homesaleId, resaleOffers, details } = props;
  const listings = details?.homesale?.listings ?? [];

  const activeListingBroker = useMemo(() => {
    const activeListing = listings.find(l => l.listingStatusId === activeListingStatusId);
    if (activeListing) {
      return brokerAgents.find(b => b.vendorId === activeListing.brokerId) || null;
    }
    return null;
  }, [details?.homesaleDetails?.listings, brokerAgents]);

  const offers = useMemo(() => resaleOffers.map(d => d.homesaleResaleOffer).filter(Boolean), [resaleOffers]);
  const [currentOfferId, setCurrentOfferId] = useState(offers.length > 0 ? offers[offers.length - 1].homesaleResaleOfferId : null);

  const [showAddOffer, setShowAddOffer] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  const [newBrokerId, setNewBrokerId] = useState(null);
  const [newBrokerName, setNewBrokerName] = useState('');

  const selectedDto = useMemo(() => resaleOffers.find(d => d.homesaleResaleOffer?.homesaleResaleOfferId === currentOfferId) || null, [
    resaleOffers,
    currentOfferId
  ]);

const selectedBrokerAgents = brokerAgents.filter(agent =>
  listings.some(listing =>
    listing.brokerId === agent.vendorId &&
    listing.listingStatusId === activeListingStatusId
  )
);

const brokerAgentSearchInfo = brokerSearchInfo(selectedBrokerAgents);
  const refreshOffers = async (keepId = null) => {
    const allResp = await props.getHomesaleResaleOffers(authId, homesaleId);
    if (allResp.type === GET_ALL_HOMESALE_RESALE_OFFER_FAILURE) {
      props.showToast('Failed to fetch Homesale Resale Offers, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }
    const latestDtos = allResp.response ?? [];
    const latestOffers = latestDtos.map(x => x.homesaleResaleOffer).filter(Boolean);
    if (latestOffers.length === 0) {
      setCurrentOfferId(null);
    } else if (keepId && latestOffers.some(o => o.homesaleResaleOfferId === keepId)) {
      setCurrentOfferId(keepId);
    } else {
      setCurrentOfferId(latestOffers[latestOffers.length - 1].homesaleResaleOfferId);
    }
    return true;
  };

  const createOffer = async () => {
    setIsLoadingModal(true);

    const dto = {
      homesaleResaleOffer: {
        homesaleResaleOfferId: null,
        homesaleId: homesaleId,
        acceptDate: null,
        actualBuyoutCloseDate: null,
        actualResaleClose: null,
        brokerCommission: 0,
        brokerId: newBrokerId,
        buyer: '',
        buyerName: '',
        buyerClosingCostsAmount: 0,
        byerClosingCostsPercent: 0,
        buyerIncome: 0,
        buyerTypeId: '00000000-0000-0000-0000-000000000000',
        coBuyerIncome: 0,
        comments: '',
        concessions: 0,
        counterAmount: 0,
        earnestMoney: 0,
        employer: '',
        employmentLength: '',
        equityReturnDue: null,
        fallThroughDate: null,
        fallThroughReason: '',
        financingTypeId: '00000000-0000-0000-0000-000000000000',
        inspectionDate: null,
        inspectionReleaseDate: null,
        interestRate: 0,
        mortgageAmount: 0,
        mortgageAppDate: null,
        offerAmount: 0,
        offerDate: null,
        homesaleOfferStatusId: '00000000-0000-0000-0000-000000000000',
        ownershipTypeId: '00000000-0000-0000-0000-000000000000',
        pointsAmount: 0,
        programTypeId: '00000000-0000-0000-0000-000000000000',
        repairs: '',
        repairsAmount: 0,
        resaleCloseCoordinator: '',
        resaleCloser: '',
        resaleConcessions: 0,
        resaleContractDate: null,
        resaleDocsAddressId: null,
        resaleDocsEmail: '',
        resaleDocsFax: '',
        resaleDocsPhone: '',
        resaleDocsSentDate: null,
        resaleDocsSentTo: '',
        resaleHomeWarranty: 0,
        resalePrice: 0,
        resaleRepairs: 0,
        scheduledBuyout: null,
        scheduledCloseDate: null,
        scheduledResaleClose: null,
        subjectTo: '',
        trueSalePrice: 0,
        warranty: 0,
        addedBy: 0,
        addedOn: new Date().toISOString(),
        modifiedBy: 0,
        modifiedOn: null
      },
      titleCoAddress: {
        addressId: 0,
        addressTypeId: '00000000-0000-0000-0000-000000000000',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        city: '',
        county: '',
        countryId: '00000000-0000-0000-0000-000000000000',
        provinceId: '00000000-0000-0000-0000-000000000000',
        zipcode: '',
        addedBy: 0,
        addedOn: new Date().toISOString(),
        modifiedBy: 0,
        modifiedOn: null
      }
    };

    const resp = await props.postHomesaleResaleOffer(authId, homesaleId, dto);
    if (resp.type === POST_HOMESALE_RESALE_OFFER_FAILURE) {
      props.showToast('Failed to create Homesale Resale Offer, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingModal(false);
      return;
    }

    await refreshOffers();
    props.showToast('New offer created successfully.', { userMustDismiss: false, severity: 'success' });
    setShowAddOffer(false);
    setIsLoadingModal(false);
  };

  const startNewOffer = () => {
    if (activeListingBroker) {
      setNewBrokerId(activeListingBroker.vendorId);
      setNewBrokerName(activeListingBroker.companyName);
    }
    setShowAddOffer(true);
  };

  const deleteOffer = async () => {
    if (!currentOfferId) return;
    const resp = await props.deleteHomesaleResaleOffer(authId, homesaleId, currentOfferId);
    if (resp.type === DELETE_HOMESALE_RESALE_OFFER_FAILURE) {
      props.showToast('Failed to delete the Homesale Resale Offer, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }
    props.showToast('Offer deleted successfully.', { userMustDismiss: false, severity: 'success' });

    await refreshOffers();
  };

  useEffect(() => {
    if (!currentOfferId && offers.length > 0) {
      setCurrentOfferId(offers[offers.length - 1].homesaleResaleOfferId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offers.length]);

  return (
    <Box>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
          <Box>
            <div className={props.classes.mb2}>
              <Typography variant="subtitle2">Offer</Typography>
            </div>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Select
                labelId="offerSelect"
                key="offerSelect"
                name="offerId"
                value={currentOfferId ?? ''}
                displayEmpty
                sx={{ maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setCurrentOfferId(e.target.value || null)}
              >
                {offers.length > 0 ? (
                  offers.map(opt => {
                    const broker = brokerAgents?.find(a => a.vendorId === opt.brokerId);
                    const brokerName = broker?.companyName ? broker.companyName.trim() : '';
                    const label = `${brokerName} (Offer ID ${opt.homesaleResaleOfferId})`;
                    return (
                      <MenuItem key={opt.homesaleResaleOfferId} value={opt.homesaleResaleOfferId} sx={{ margin: 'dense' }}>
                        {label}
                      </MenuItem>
                    );
                  })
                ) : (
                  <MenuItem value="" disabled>
                    <em>No offers</em>
                  </MenuItem>
                )}
              </Select>
              {!isReadOnly && (
                <Button
                  color="secondary"
                  type="button"
                  variant="contained"
                  sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                  onClick={() => startNewOffer()}
                >
                  New Offer
                </Button>
              )}
            </Box>
          </Box>
        </Box>

        {!isReadOnly && !currentOfferId && (
          <Box sx={{ padding: '20px', paddingTop: '165px', fontSize: '20px' }}>
            <b>No offer selected. Create a new offer above to get started.</b>
          </Box>
        )}

        {currentOfferId && selectedDto && (
          <Grid container>
            <ResaleOffersCard
              offerDto={selectedDto}
              offerId={currentOfferId}
              authId={authId}
              homesaleId={homesaleId}
              deleteOffer={deleteOffer}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              refreshOffers={refreshOffers}
              brokerAgents={brokerAgents}
            />
          </Grid>
        )}

        <Dialog open={showAddOffer} fullWidth={false} maxWidth="lg">
          <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box sx={{ marginRight: '20px' }}>
              <AdvancedSearch
                labelText="Broker"
                displayValueAccessorKey={brokerAgentSearchInfo.nameKey}
                saveIdValueAccessorKey={brokerAgentSearchInfo.idKey}
                searchingCriteria={brokerAgentSearchInfo.searchingColumns}
                searchingCriteriaExtensions={brokerAgentSearchInfo.searchingColumnExtensions}
                searchingRows={brokerAgentSearchInfo.searchingRows}
                id={newBrokerId}
                value={newBrokerName}
                setIdValue={(brokerId, value) => {
                  setNewBrokerId(brokerId ?? null);
                  setNewBrokerName(value ?? '');
                }}
                isReadOnly={isReadOnly}
              />
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          </Box>
          <DialogActions sx={{ p: '1.25rem' }}>
            {isLoadingModal && <Spinner />}
            {!isReadOnly && !isLoadingModal && (
              <>
                <Button onClick={() => setShowAddOffer(false)}>Cancel</Button>
                <Button onClick={createOffer} color="primary" type="submit" variant="contained" disabled={!newBrokerName}>
                  Create Offer
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
      </Grid>
    </Box>
  );
};

ResaleOffers.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {};
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getHomesaleResaleOffers,
    postHomesaleResaleOffer,
    deleteHomesaleResaleOffer,
    showToast
  })
)(ResaleOffers);
